import { CheckCircle, CheckIcon, ThinCircleIcon } from '../utils/Icons'

export const getAllSegmentStatusMarkers = ({ className, tooltip = '' }: { className: string; tooltip?: string }) => {
    return [
        <CheckIcon className={className} tooltip={tooltip} />,
        <ThinCircleIcon className={className} tooltip={tooltip} />,
        <CheckCircle className={className} tooltip={tooltip} />
    ]
}
